import {
  IonButton,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
} from "@ionic/react";
import { useEffect } from "react";
import "./PageNotFound.css";

const PageNotFound: React.FC = () => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/";
    }, 1500);
  }, []);

  return (
    <IonContent className="content404">
      <IonGrid className="grid404">
        <IonHeader className="header404">Error 404</IonHeader>
        <IonItem className="item404">
          Cette page n'est pas disponible. Vous allez être redirigé.
        </IonItem>
        <div className="ion-text-center">
          <IonButton href="/" className="button404">
            Revenir en lieu sûr
          </IonButton>
        </div>
      </IonGrid>
    </IonContent>
  );
};

export default PageNotFound;
